export default "__VITE_ASSET__20560667__"